
import { UseFormReturn } from "react-hook-form";
import { FormData } from "@/components/clients/utils/clientFormSchema";

export const validateCurrentStep = async (
  form: UseFormReturn<FormData>,
  activeTab: string
): Promise<boolean> => {
  if (activeTab === "details") {
    const fields = ["firstName", "lastName", "email", "birthDate", "gender", "phone", "address", "notes", "paymentStatus"] as const;
    const isValid = await form.trigger(fields);
    return isValid;
  }
  return true;
};

export const validateAndNavigateToFirstError = async (
  form: UseFormReturn<FormData>,
  setActiveTab: (tab: string) => void
): Promise<{ isValid: boolean; errorTab?: string; errorField?: string }> => {
  console.log('=== VALIDATION STARTED ===');
  
  // Define field groups for each tab
  const detailsFields = ["firstName", "lastName", "email", "birthDate", "gender", "phone", "address", "notes", "paymentStatus"] as const;
  const subscriptionsFields = ["subscriptions"] as const;

  // Get current form state
  console.log('Current form values:', form.getValues());
  console.log('Current form errors before trigger:', form.formState.errors);

  // Validate all fields
  const allFieldsValid = await form.trigger();
  
  console.log('All fields valid after trigger:', allFieldsValid);
  console.log('Form errors after trigger:', form.formState.errors);
  
  if (allFieldsValid) {
    console.log('All fields are valid, proceeding');
    return { isValid: true };
  }

  // Get current form errors
  const formErrors = form.formState.errors;
  console.log('Form errors found:', Object.keys(formErrors));
  
  // Check details tab first
  for (const field of detailsFields) {
    if (formErrors[field]) {
      console.log(`Found error in details field: ${field}, switching to details tab`);
      setActiveTab("details");
      
      // Focus on the first error field after a small delay to ensure tab switch completes
      setTimeout(() => {
        console.log(`Attempting to focus on field: ${field}`);
        const errorElement = document.querySelector(`[name="${field}"]`) as HTMLElement;
        console.log('Error element found:', !!errorElement);
        if (errorElement) {
          errorElement.focus();
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 150); // Increased delay to ensure tab switch completes
      
      return { isValid: false, errorTab: "details", errorField: field };
    }
  }

  // Check subscriptions tab
  if (formErrors.subscriptions) {
    console.log('Found error in subscriptions, switching to subscriptions tab');
    setActiveTab("subscriptions");
    
    // Focus on the first subscription error field or the workout type selector
    setTimeout(() => {
      const errorElement = document.querySelector('[name="subscriptions.0.sessionsPerMonth"]') as HTMLElement ||
                           document.querySelector('[name="subscriptions.0.totalPrice"]') as HTMLElement ||
                           document.querySelector('[data-testid="workout-type-select"]') as HTMLElement ||
                           document.querySelector('button[role="combobox"]') as HTMLElement;
      console.log('Subscription error element found:', !!errorElement);
      if (errorElement) {
        errorElement.focus();
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);
    
    return { isValid: false, errorTab: "subscriptions", errorField: "subscriptions" };
  }

  console.log('No specific field errors found, but validation failed');
  return { isValid: false };
};
